import axios from "axios";
import { SHOPIFY_STOREFRONT_GRAPHQL_API, SHOPIFY_STOREFRONT_TOKEN } from "../../config";

export const storefrontGqlClient = axios.create({
    baseURL: SHOPIFY_STOREFRONT_GRAPHQL_API,
    headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": SHOPIFY_STOREFRONT_TOKEN,
    },
});
